import { TWELVE_HOURS, TWENTY_FOUR_HOURS } from './_api';
import request from '@core/services/request';
import SaturnResponse from '@core/classes/Responses/SaturnResponse';
import { StockNumberLookupTable } from '@core/classes/StockNumberLookupTable';
import VAutoLookupResponse from '@core/classes/Responses/VAutoLookupResponse';
import { VINInfo } from '@core/classes/VINInfo';

export const vehicleAPI = {
	vinLookup: (vin: string, inventoryType: string = null, skipDBCheck = false, cache = true) =>
		request.get<SaturnResponse<VINInfo>>(`/Lookup/DecodeVin/${vin}/${inventoryType}/${skipDBCheck}`, { cache: false, maxAge: TWENTY_FOUR_HOURS }),
	stockNumberLookup: (stockNumber: string) =>
		request.get<StockNumberLookupTable>(`/Lookup/StockNumber/` + stockNumber?.toUpperCase(), { cache: false, maxAge: TWENTY_FOUR_HOURS }),
	vAutoLookupByStockNo: (stockNumber: string) =>
		request.get<VAutoLookupResponse>(`/Lookup/VAuto/` + stockNumber?.toUpperCase(), { cache: false, maxAge: TWELVE_HOURS }),
	vAutoLookupByVin: (vin: string) => request.get<VAutoLookupResponse>(`/Lookup/VAutoByVin/` + vin?.toUpperCase()),
	saveVehicle: (vin: any, vehicle: any) => request.post(`/Lookup/SaveVehicleRecord`, { vin, vehicle }),
	carYearList: () => request.get('/Lookup/GetCarYearList'),
	carMakeList: (year: any) => request.get(`/Lookup/GetCarMakeList?year=${year}`),
	carModelList: (modelYear: any, divisionId: any) => request.get(`/Lookup/GetCarModelList?modelYear=${modelYear}&divisionId=${divisionId}`),
	carTrimList: (modelId: any) => request.get(`/Lookup/GetCarTrimList?modelId=${modelId}`),
	getVehicleRecall: (make: any, model: any, modelYear: any) => request.get(`/Lookup/GetNHTSARecall?make=${make}&model=${model}&modelYear=${modelYear}`),
	getVehicleRecallCampaign: (nhtsaCampaignNumber: any) => request.get(`/Lookup/GetNHTSARecallCampaign?campaignNumber=${nhtsaCampaignNumber}`),
};
